import { render, staticRenderFns } from "./drLiveDetail.vue?vue&type=template&id=7b038744&scoped=true"
import script from "./drLiveDetail.vue?vue&type=script&lang=js"
export * from "./drLiveDetail.vue?vue&type=script&lang=js"
import style0 from "./drLiveDetail.vue?vue&type=style&index=0&id=7b038744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b038744",
  null
  
)

export default component.exports